
const modalTitle = (state) => {
  return state.title;
}

const modalSVGType = (state) => {
  return state.svg_type;
}

const modalMessage = (state) => {
  return state.message;
}

const isModalVisible = (state) => {
  return state.visible;
}

export default {
  modalTitle,
  modalSVGType,
  modalMessage,
  isModalVisible,
}